/*
  ResetPassword.jsx
  ----------------
  Interface de réinitialisation du mot de passe.
*/
import { useEffect, useState } from "react";
import { Button, Card, Center, PasswordInput, Text } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { post, get } from "../tools/Request";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [valid, setValid] = useState(true);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      try {
        const res = await get("password/validate", { token }, null);
        setValid(res.valid);
      } catch {
        setValid(true);
      }
    };
    if (token) run();
  }, [token]);

  const onSubmit = async () => {
    if (submitting) return;
    if (!token) {
      showNotification({ title: "Token manquant", color: "red" });
      return;
    }
    if (!password || password !== password2) {
      showNotification({ title: "Les mots de passe ne correspondent pas", color: "red" });
      return;
    }
    if (password.length < 8) {
      showNotification({ title: "Le mot de passe doit contenir au moins 8 caractères", color: "red" });
      return;
    }

    try {
      setSubmitting(true);
      await post("password/reset", { token, password }, null);
      showNotification({ title: "Mot de passe mis à jour", color: "teal" });
      navigate("/login");
    } catch (err) {
      showNotification({ title: "Lien invalide ou expiré", color: "red" });
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <Center mt="20%">
        <Text>Token manquant.</Text>
      </Center>
    );
  }

  return (
    <Center mt="12%">
      <Card shadow="sm" padding="lg" radius="md" withBorder maw={420} w="100%">
        {!valid && (
          <Text c="red" mb="sm">
            Le lien semble invalide ou expiré. Essayez d’en redemander un.
          </Text>
        )}
        <PasswordInput
          label="Nouveau mot de passe"
          placeholder="••••••••"
          mt="md"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <PasswordInput
          label="Confirmer le mot de passe"
          placeholder="••••••••"
          mt="md"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit();
          }}
        />
        <Button mt="lg" onClick={onSubmit} loading={submitting} disabled={submitting}>
          Réinitialiser le mot de passe
        </Button>
      </Card>
    </Center>
  );
}
